import * as Team from "src/state/modules/team";
import { SortableTeamMember, teamMemberOrPlayerComparator } from "./comparators";

export function sortTeamMembers<I extends SortableTeamMember>(members: I[]): I[] {
  return [...members].sort(teamMemberOrPlayerComparator);
}

export const sortPlayers = (players: Team.Player[]): Team.Player[] => {
  return [...players].sort(teamMemberOrPlayerComparator);
};

// export const sortStaff = (staff: TeamMember.TeamMemberUser[]): TeamMember.TeamMemberUser[] => {
//     return [...staff].sort(teamMemberOrPlayerComparator);
// };
